export function slugifyTopic(topic: string) {
    return topic
      .toLowerCase()
      .replace(/\s+/g, "-")        // replace spaces with -
      .replace(/[^a-z0-9-]/g, ""); // strip non-alphanumeric except -
  }

export function unslugify(input: unknown): string {
  const s = (input ?? "").toString();
  // Split/join avoids any regex edge cases
  return s.split("-").join(" ")
          .split("_").join(" ")   // if underscores sneak in
          .replace(/\s+/g, " ")    // collapse spaces
          .trim()
          .toLowerCase();
}